<div class="oiq-ui-dialog" (keydown.esc)="close()" tabindex="0">
  <header>
    <div class="__title">
      <div>
        <h2>{{ data?.title || 'Link to existing client' }}</h2>
      </div>
      <button (click)="close()" class="oiq-button oiq-button--link __close" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <main class="space-y-2 !pt-4">
    @if (!data.clientId) {
      <div class="mb-4 flex w-full flex-col gap-2 border-b border-gray-4 pb-4">
        <div class="flex items-center gap-2">
          <svg
            width="13"
            height="15"
            viewBox="0 0 13 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.2105 2.97703L9.39797 0.164531C9.34569 0.112312 9.28364 0.0709042 9.21535 0.0426734C9.14707 0.0144426 9.07389 -5.79295e-05 9 1.73924e-07H3.375C3.07663 1.73924e-07 2.79048 0.118527 2.57951 0.329505C2.36853 0.540483 2.25 0.826632 2.25 1.125V2.25H1.125C0.826631 2.25 0.540483 2.36853 0.329505 2.57951C0.118526 2.79048 0 3.07663 0 3.375V13.5C0 13.7984 0.118526 14.0845 0.329505 14.2955C0.540483 14.5065 0.826631 14.625 1.125 14.625H9C9.29837 14.625 9.58452 14.5065 9.79549 14.2955C10.0065 14.0845 10.125 13.7984 10.125 13.5V12.375H11.25C11.5484 12.375 11.8345 12.2565 12.0455 12.0455C12.2565 11.8345 12.375 11.5484 12.375 11.25V3.375C12.3751 3.30111 12.3606 3.22793 12.3323 3.15965C12.3041 3.09136 12.2627 3.02931 12.2105 2.97703ZM9 13.5H1.125V3.375H6.51727L9 5.85773V11.8012C9 11.8055 9 11.809 9 11.8125C9 11.816 9 11.8195 9 11.8238V13.5ZM11.25 11.25H10.125V5.625C10.1251 5.55111 10.1106 5.47793 10.0823 5.40965C10.0541 5.34136 10.0127 5.27931 9.96047 5.22703L7.14797 2.41453C7.09569 2.36231 7.03364 2.3209 6.96535 2.29267C6.89707 2.26444 6.82389 2.24994 6.75 2.25H3.375V1.125H8.76727L11.25 3.60773V11.25ZM7.3125 9C7.3125 9.14918 7.25324 9.29226 7.14775 9.39775C7.04226 9.50324 6.89918 9.5625 6.75 9.5625H3.375C3.22582 9.5625 3.08274 9.50324 2.97725 9.39775C2.87176 9.29226 2.8125 9.14918 2.8125 9C2.8125 8.85082 2.87176 8.70774 2.97725 8.60225C3.08274 8.49676 3.22582 8.4375 3.375 8.4375H6.75C6.89918 8.4375 7.04226 8.49676 7.14775 8.60225C7.25324 8.70774 7.3125 8.85082 7.3125 9ZM7.3125 11.25C7.3125 11.3992 7.25324 11.5423 7.14775 11.6477C7.04226 11.7532 6.89918 11.8125 6.75 11.8125H3.375C3.22582 11.8125 3.08274 11.7532 2.97725 11.6477C2.87176 11.5423 2.8125 11.3992 2.8125 11.25C2.8125 11.1008 2.87176 10.9577 2.97725 10.8523C3.08274 10.7468 3.22582 10.6875 3.375 10.6875H6.75C6.89918 10.6875 7.04226 10.7468 7.14775 10.8523C7.25324 10.9577 7.3125 11.1008 7.3125 11.25Z"
              fill="#606B84" />
          </svg>
          <p class="text-lg font-medium leading-none text-[#606B84]">
            Select For Application/Funding
          </p>
        </div>
        <p class="text-sm leading-none text-gray-2">
          Select an application/funding from the list below
        </p>
      </div>
      <div class="mb-6 flex w-full items-center justify-between gap-4">
        <form [formGroup]="searchForm" class="w-full">
          <oiq-form-input
            #nameInputRef="OiqFormElement"
            placeholder="Search Client"
            formControlName="name"
            prefixIcon="search"
            class="min-w-96"></oiq-form-input>
        </form>
      </div>
    }

    @if (clientResults().length === 0 && searchControl.value) {
      <div class="no-results">
        <img src="assets/images/no-clients.png" alt="No clients found" />
        <h4>Please, check your search</h4>
        <div class="flex items-center justify-center gap-2">
          <p>Please, check your search</p>
          <span>or</span>
          <button
            type="button"
            class="text-primary disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="appDialogsDisabled()"
            (click)="onCreateNewApplication()">
            Create New Application
          </button>
        </div>
      </div>
    } @else if (clientResults().length > 0) {
      @for (client of clientResults(); track client.id) {
        <oiq-ui-panel
          #panelRef="OiqUiPanel"
          [titleText]="client.name"
          (event)="handlePanelEvent($event, client)"
          [collapsable]="true"
          [initialyCollapsed]="!data.clientId"
          class="oiq-ui-panel__reverse oiq-ui-panel__hoverable group shadow-none">
          <ng-template #panelRight>
            <div
              class="flex w-full flex-nowrap items-center justify-between"
              (click)="panelRef.handleToggle()">
              <div class="client-info">
                <div>
                  <span>ID:&nbsp;</span>
                  <span class="font-medium">{{ client.id }}</span>
                </div>
                <div>
                  <span>ISO:&nbsp;</span>
                  <span class="font-medium">{{ client.isoName || 'N/A' }}</span>
                </div>
              </div>

              <div class="flex flex-nowrap items-center gap-x-3">
                <span class="whitespace-nowrap text-xs text-gray-1">{{ client.date }}</span>
                <button
                  class="oiq-button oiq-button--primary--solid btn-sm none group-hover:visible group-hover:inline-block"
                  [ngClass]="{ invisible: this.expandedElement !== client }"
                  (click)="selectClient(client); $event.stopPropagation()">
                  Select
                </button>
              </div>
            </div>
          </ng-template>
          <!-- Applications/transactions table inside expansion panel -->
          <oiq-grid-table
            [data]="client.transactions"
            [configuration]="{
              borderedHeaders: true,
              canExport: false,
              canFullscreen: false,
              showRefresh: false,
              colored: false
            }"
            class="client-search-dialog-table block border-none bg-white px-4 py-2">
            <ng-template #gridHeaderColumns>
              <tr>
                <th>ID</th>
                <th>Funded&nbsp;Amount</th>
                <th>Referring&nbsp;ISO</th>
                <th>Date&nbsp;Submitted</th>
                <th>Status</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #gridItem let-item>
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.iso?.name || (typeof item.iso === 'string' ? item.iso : 'N/A') }}</td>
                <td>{{ item.date }}</td>
                <td>
                  <div class="my-auto flex items-center gap-x-3">
                    <span
                      class="rounded-md bg-gray-5 p-1 px-2.5 text-xs"
                      [ngClass]="'status-' + item.status.toLowerCase()"
                      >{{ item.status | status }}</span
                    >
                  </div>
                </td>
                <td>
                  <button
                    class="oiq-button oiq-button--outline"
                    (click)="selectApplication(item, client)">
                    Select
                  </button>
                </td>
              </tr>
            </ng-template>
          </oiq-grid-table>
        </oiq-ui-panel>
      }
    }
  </main>
  <footer>
    <div class="__left"><!-- LEFT --></div>
    <div class="__right">
      <button class="oiq-button oiq-button--outline" (click)="close()">Hide</button>
    </div>
  </footer>
</div>
